import { GovSkeleton } from '@gov-design-system-ce/react';
import { useGlobalLocale } from '@gov-nx/core/service';
import { ButtonGroupLayout, ContentLayout, LayoutGap } from '@gov-nx/ui/web';

export const MyAuthorizationDetailSkeleton = () => {
	const { t } = useGlobalLocale();
	return (
		<LayoutGap>
			<GovSkeleton
				width="240px"
				height="24px"
				aria-label={t('loading.wcag.processing')}
				className="skeleton-brighter mb-(--templates-margin-xl)!"
			/>
			<ContentLayout>
				<LayoutGap gap="l">
					<GovSkeleton
						width="270px"
						height="50px"
						aria-label={t('loading.wcag.processing')}
					/>
					<div className="flex gap-2">
						<GovSkeleton
							width="22px"
							height="22px"
							aria-label={t('loading.wcag.processing')}
						/>
						<GovSkeleton
							width="90%"
							height="22px"
							aria-label={t('loading.wcag.processing')}
						/>
					</div>
					<ButtonGroupLayout>
						<GovSkeleton
							width="150px"
							height="38px"
							aria-label={t('loading.wcag.processing')}
						/>
						<GovSkeleton
							width="190px"
							height="38px"
							aria-label={t('loading.wcag.processing')}
						/>
					</ButtonGroupLayout>
				</LayoutGap>
			</ContentLayout>
		</LayoutGap>
	);
};
